import { SubmissionDetailPage } from '@/pages/SubmissionDetail'
import { GuidedSetupPage } from '@/pages/GuidedSetup'
import { LocalCataloguePage } from '@/pages/LocalCatalogue'
import { LocalImportsPage } from '@/pages/LocalImports'
import { centralEnabled } from '@/config/api';
import { CentralSignIn, CentralCallback, AccountsRedirect, CentralAccess } from '@/pages/CentralAccounts';
import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth, RequireRole } from "@/components/auth/RequireAuth";
import { AppLayout } from "@/components/layout/AppLayout";
import { adminRoles, editorRoles, ownerRole } from "@/helpers/roles";
import {
  DashboardScreen,
  CustomersScreen,
  CustomerEditor,
  CustomerDetail,
  ActionsScreen,
  AddActionScreen,
} from "@/pages/CrmScreens";
import { ReportsScreen, AdminScreen } from "@/pages/ManagementScreens";
import { ForgotPasswordPage } from "@/pages/ForgotPassword";
import { NotFoundPage } from "@/pages/NotFound";
import { SelectBusinessPage } from "@/pages/SelectBusiness";
import { SignUpPage } from "@/pages/SignUp";
import { SignInPage } from "@/pages/SignIn";
import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
const OrderFormsScreen = lazy(() => import('@/pages/OrderForms').then(module => ({ default: module.OrderFormsScreen })));
const OrderFormBuilder = lazy(() => import('@/pages/OrderForms').then(module => ({ default: module.OrderFormBuilder })));
import { SubscriptionPage } from "@/pages/Subscription";
import { AddNoteScreen } from "@/pages/AddNote";
import { CreateOrderScreen } from "@/pages/CreateOrder";
import { OrdersPage } from "@/pages/Orders";
export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingSpinner text="Loading workspace" />}><Routes>
      <Route path="/auth/callback" element={<CentralCallback />} />
      <Route path="/accounts/access" element={<CentralAccess />} />
      <Route path="/signin" element={centralEnabled ? <CentralSignIn /> : <SignInPage />} />
      <Route path="/signup" element={centralEnabled ? <AccountsRedirect path="/register?product=crm" /> : <SignUpPage />} />
      <Route path="/join" element={centralEnabled ? <AccountsRedirect path="/register?product=crm" /> : <SignUpPage />} />
      <Route path="/forgot-password" element={centralEnabled ? <AccountsRedirect path="/identity-email" /> : <ForgotPasswordPage />} />
      <Route path="/select-business" element={<SelectBusinessPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardScreen />} />
          <Route path="/setup" element={<RequireRole roles={adminRoles}><GuidedSetupPage key="crm-setup" /></RequireRole>} />
          <Route path="/submissions/:id" element={<SubmissionDetailPage />} />
          <Route path="/catalogue" element={<LocalCataloguePage />} />
          <Route path="/imports" element={<RequireRole roles={adminRoles}><LocalImportsPage /></RequireRole>} />
          <Route
            path="/customers/new"
            element={
              <RequireRole roles={editorRoles}>
                <CustomerEditor />
              </RequireRole>
            }
          />
          <Route
            path="/customers/:id/edit"
            element={
              <RequireRole roles={editorRoles}>
                <CustomerEditor />
              </RequireRole>
            }
          />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route
            path="/actions/mine"
            element={
              <RequireRole roles={editorRoles}>
                <ActionsScreen />
              </RequireRole>
            }
          />
          <Route
            path="/actions/team"
            element={
              <RequireRole roles={editorRoles}>
                <ActionsScreen team />
              </RequireRole>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireRole roles={adminRoles}>
                <OrdersPage />
              </RequireRole>
            }
          />
          <Route
            path="/orders/new/:customerId"
            element={
              <RequireRole roles={editorRoles}>
                <CreateOrderScreen />
              </RequireRole>
            }
          />
          <Route
            path="/notes/new/:customerId"
            element={
              <RequireRole roles={editorRoles}>
                <AddNoteScreen />
              </RequireRole>
            }
          />
          <Route
            path="/actions/new/:customerId?"
            element={
              <RequireRole roles={editorRoles}>
                <AddActionScreen />
              </RequireRole>
            }
          />
          <Route path="/reports/:report" element={<ReportsScreen />} />
          {["/admin/forms", "/admin/forms/new", "/admin/forms/:id/edit"].map(
            (path) => (
              <Route
                key={path}
                path={path}
                element={
                  <RequireRole roles={adminRoles}>
                    {path === "/admin/forms" ? (
                      <OrderFormsScreen />
                    ) : (
                      <OrderFormBuilder />
                    )}
                  </RequireRole>
                }
              />
            ),
          )}
          <Route
            path="/admin/subscription"
            element={
              <RequireRole roles={[ownerRole]}>
                {centralEnabled ? <AccountsRedirect path="/subscriptions" /> : <SubscriptionPage />}
              </RequireRole>
            }
          />
          <Route path="/admin/account" element={<Navigate to="/admin/business-details" replace />} />
          <Route
            path="/admin/:section"
            element={
              <RequireRole roles={adminRoles}>
                <AdminScreen />
              </RequireRole>
            }
          />
          <Route path="/customers" element={<CustomersScreen />} />
          <Route
            path="/actions"
            element={
              <RequireRole roles={editorRoles}>
                <ActionsScreen />
              </RequireRole>
            }
          />
          <Route path="/reports" element={<ReportsScreen />} />
          <Route
            path="/admin"
            element={
              <RequireRole roles={adminRoles}>
                <AdminScreen />
              </RequireRole>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes></Suspense>
  );
}
